import React, { useState } from "react";
import Loader from "../../components/loader";
import UiTable from "../../components/table/Table";
import { ethers } from "ethers";
import Web3 from "web3";
import {
  useClientKYCData,
  useNetworkOptions,
} from "../../context/contractDataLoaderService";
import { Client, contractAddress } from "@verified-network/verified-sdk";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../context/globalContext";
import VerticallyModal from "../../components/modal/VerticallyModal";
import TextInput from "../../components/textinput/TextInput";
import UiButton from "../../components/button";
import { Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import {
  approveOrRejectApplicant,
  changeApllicantName,
  check5MB,
  encryptKycString,
  fixApplicantRejections,
  getBase64DisplayUrl,
  getBase64DisplayUrlTag,
  getDownloadExt,
  getFileSizeInMB,
  getMimeTypeFromBase64,
  getUser,
  saveKycQuestionnaire,
  sendMessageToApplicant,
  uploadFileToFirebase,
} from "./kycUtils";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  sumsubRejectionReasonsObj,
  kycTexts,
} from "../../utils/constants";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import Select from "react-select";
import { hashTheString } from "@verified-network/verified-custody";

function KYCList(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    userCountryCode,
    verifiedWalletDetails,
    userSignature,
    userSignatureNonce,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  let { data: kycList, loading: kycLoading } = useClientKYCData(
    false,
    true,
    "",
    [0, 1, 2],
  );
  const [showModal, setShowModal] = useState(false);
  const [modalView, setModalView] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [kycMessage, setKycMessage] = useState("");
  const [kycMessageSubject, setKycMessageSubject] = useState("");
  const [newApplicantName, setNewApplicantName] = useState(null);
  const [messageApplicantName, setMessageApplicantName] = useState(null);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [applicantDoc, setApplicantDoc] = useState();
  const [applicantSelfie, setApplicantSelfie] = useState();
  const [applicantQuestionnaireDocs, setApplicantQuestionnaireDocs] =
    useState();
  const [questionaireDocsLoading, setQuestionaireDocsLoading] = useState(false);
  const [userDtLoading, setUserDtLoading] = useState(false);
  const [userDt, setUserDt] = useState({});
  const [newUserDt, setNewUserDt] = useState({});
  const [applicantMessages, setApplicantMessages] = useState([]);
  const [generalLoading, setGeneralLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [filterContent, setFilterContent] = useState(null);
  const [value, onChange] = useState(new Date());
  const [value2, onChange2] = useState(new Date());
  const [newData, setNewData] = useState(null);
  const [changeContent, setChangeContent] = useState(false);
  const [newLink, setNewLink] = useState("");
  const [uniqueRejections, setUniqueRejections] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [showEmailSample, setShowEmailSample] = useState(false);
  const [showChangeFile, setShowChangeFile] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);

  let message, heading;

  const handleModalHide = () => {
    setSelectedUser(null);
    setModalView(0);
    setShowModal(false);
    setNewApplicantName(null);
    setMessageApplicantName(null);
    setShowSaveButton(false);
    setFilterContent(null);
    setApplicantDoc();
    setApplicantSelfie();
    setApplicantQuestionnaireDocs();
    setNewLink("");
    setUniqueRejections([]);
    setIsDuplicate(false);
    setApplicantMessages([]);
    setKycMessage("");
    setKycMessageSubject("");
    setUserDt({});
    setUserDtLoading(false);
    setShowEmailSample(false);
    setShowChangeFile(false);
    setFileToUpload(null);
    setLoader(false);
    setUserDt({});
  };

  const commonProps = {
    changeContent,
    updateChangeContent: setChangeContent,
    modalView,
    updateModalView: setModalView,
    showModal,
    updateShowModal: setShowModal,
    selectedUser,
    updateSelectedUser: setSelectedUser,
    applicantDoc,
    updateApplicantDoc: setApplicantDoc,
    newApplicantName,
    applicantSelfie,
    updateApplicantSelfie: setApplicantSelfie,
    updateApplicantMessages: setApplicantMessages,
    generalLoading,
    updateGeneralLoading: setGeneralLoading,
    updateQuestionaireDocsLoading: setQuestionaireDocsLoading,
    updateApplicantQuestionnaireDocs: setApplicantQuestionnaireDocs,
    updateUserDtLoading: setUserDtLoading,
    updateUserDt: setUserDt,
    updateLoader: setLoader,
  };
  const { data: networkOptions } = useNetworkOptions();
  const headers = [
    { label: "Date", val: "createdAt" },
    { label: "Wallet address", val: "fullAddress" },
    { label: "Name", val: "fullName" },
    { label: "Applicant ID", val: "applicantId" },
    { label: "Country", val: "countryName" },
    { label: "Staus", val: "applicantStatus" },
    { label: "Onchain Status", val: "statusText" },
    // { label: "Photo/Video KYC", val: "selfieURL" },
    // { label: "Indentity KYC", val: "identityURL" },
    { label: "Actions", val: "kycAction" },
  ];

  const processedData = kycList?.filter((kyc) => {
    if (kyc && Number(kyc.status) !== 3) {
      return kyc;
    }
  });

  if (modalView === 10) {
    heading = "Send Kyc Message";
    message = (
      <div className="d-grid gap-2">
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Email</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Applicant email"
                disabled={true}
                value={selectedUser ? selectedUser["email"] : ""}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Name</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Applicant name"
                onChange={(e) => setMessageApplicantName(e.target.value)}
                value={
                  selectedUser && messageApplicantName === null
                    ? selectedUser["fullName"]
                    : messageApplicantName
                }
              />
            </Col>
          </Row>
          {!showEmailSample && (
            <React.Fragment>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Subject</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  <textarea
                    onChange={(e) => setKycMessageSubject(e.target.value)}
                    name="KycMessageSubject"
                    style={{
                      minHeight: "50px",
                      width: "300px",
                      border: "1px solid black",
                    }}
                  >
                    {kycMessageSubject}
                  </textarea>
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Message</b>
                </Col>
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  Format:
                  <span style={{ color: "blue" }}>
                    Opening Greeting/Salutation: Hi/Hello [User name], /n/n
                  </span>
                  <span style={{ color: "red" }}>
                    Note: /n/n is required after greetings, every text before
                    /n/n is considered greeting
                  </span>
                  <span style={{ color: "blue" }}>
                    Paragrah 1: Brief explanation on what you want to
                    commuinicate /n.{" "}
                  </span>
                  <span style={{ color: "red" }}>
                    Note: /n is required after paragraph 1, to diferenciate it
                    from paragraph 2. any texts after /n/n and before /n is
                    considered paragraph 1
                  </span>
                  <span style={{ color: "blue" }}>
                    Paragrah 2: Optional; It is to commuicate explanation or
                    additional requirement not mentioned in paragraph 1
                  </span>
                  <span style={{ color: "red" }}>
                    Note: No Closing greeting/salutation is required it will be
                    automatically added.
                  </span>
                </p>

                <textarea
                  onChange={(e) => setKycMessage(e.target.value)}
                  name="kycMessage"
                  style={{
                    minHeight: "190px",
                    width: "100%",
                    border: "1px solid black",
                  }}
                >
                  {kycMessage}
                </textarea>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col className="pl-0">
                  <UiButton
                    onClick={async () => {
                      if (kycMessage === "") {
                        toast.error("Message can not be empty", ToastOptions);
                        return;
                      }
                      if (kycMessageSubject === "") {
                        toast.error(
                          "Message subject can not be empty",
                          ToastOptions,
                        );
                        return;
                      }
                      if (!selectedUser || selectedUser["email"].length < 1) {
                        toast.error(
                          "Error while getting applicant's email try again later",
                          ToastOptions,
                        );
                        return;
                      }
                      setShowEmailSample(true);
                    }}
                    buttonVariant="primary"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText="View Email Samle"
                    type="submit"
                  />
                </Col>
              </Row>
            </React.Fragment>
          )}
          {showEmailSample && (
            <React.Fragment>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Subject:</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  <p>{kycMessageSubject}</p>
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Message:</b>
                </Col>
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <span>{kycMessage?.split("/n/n")[0]}</span>
                  <span>{kycMessage?.split("/n/n")[1]?.split("/n")[0]}</span>
                  <span>{kycMessage?.split("/n/n")[1]?.split("/n")[1]}</span>
                </p>
                <p></p>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col className="pl-0">
                  <UiButton
                    onClick={async () => {
                      setShowEmailSample(false);
                    }}
                    buttonVariant="secondary"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText="Edit Message"
                    type="submit"
                  />
                </Col>

                <Col className="pl-0">
                  <UiButton
                    onClick={async () => {
                      if (kycMessage === "") {
                        toast.error("Message can not be empty", ToastOptions);
                        return;
                      }
                      if (kycMessageSubject === "") {
                        toast.error(
                          "Message subject can not be empty",
                          ToastOptions,
                        );
                        return;
                      }
                      if (!selectedUser || selectedUser["email"].length < 1) {
                        toast.error(
                          "Error while getting applicant's email try again later",
                          ToastOptions,
                        );
                        return;
                      }

                      setGeneralLoading(true);
                      await sendMessageToApplicant(
                        selectedUser["email"],
                        "",
                        kycMessageSubject,
                        kycMessage,
                        "send_email",
                      ).then((res) => {
                        setGeneralLoading(false);
                        res
                          ? toast.success(
                              "Message sent succesfully",
                              ToastOptions,
                            )
                          : toast.error(
                              "Error while sending message",
                              ToastOptions,
                            );
                        if (res) {
                          setShowEmailSample(false);
                          handleModalHide();
                        }
                      });
                    }}
                    buttonVariant="primary"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText="Send Email"
                    type="submit"
                  />
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Row>
      </div>
    );
  } else if (modalView == 2) {
    heading = "Apllicant Portal";
    message = (
      <div className="d-grid gap-2">
        {loader ? <Loader /> : null}
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Id</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["applicantId"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Address</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["accountAddress"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Name</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Applicant's name(firstname lastname)"
                value={
                  selectedUser && !showSaveButton && newApplicantName === null
                    ? selectedUser["fullName"]
                    : showSaveButton
                      ? newApplicantName
                      : ""
                }
                onChange={(e) => {
                  setNewApplicantName(e.target.value);
                  e.target.value !== ""
                    ? setShowSaveButton(true)
                    : setShowSaveButton(false);
                }}
              />
              {showSaveButton && (
                <UiButton
                  onClick={async () => {
                    const nameSplit = newApplicantName.split(" ");
                    if (nameSplit.length < 2) {
                      toast.error(
                        "Appllicant's name must include first and last name",
                        ToastOptions,
                      );
                      return;
                    }
                    setLoader(true);
                    const firstName =
                      nameSplit.length > 0 ? nameSplit[0] : newApplicantName;
                    const middleName =
                      nameSplit.length > 2
                        ? nameSplit[nameSplit.length - 2]
                        : "";
                    const lastName =
                      nameSplit.length > 1
                        ? nameSplit[nameSplit.length - 1]
                        : "";
                    await changeApllicantName(
                      selectedUser["applicantId"],
                      firstName,
                      lastName,
                      middleName,
                    ).then((res) => {
                      setLoader(false);
                      res
                        ? toast.success(
                            "Appllicant's name changed succesfully",
                            ToastOptions,
                          )
                        : toast.error(
                            "Appllicant's name change request failed",
                            ToastOptions,
                          );
                      if (res) {
                        setShowSaveButton(false);
                        handleModalHide();
                      }
                    });
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Save Changes"
                  type="submit"
                />
              )}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Email</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["email"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Applicant Country</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["countryName"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Investor Type</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser &&
              selectedUser["applicantData"]["questionnaires"] &&
              selectedUser["applicantData"]["questionnaires"][0]["sections"][
                "documentsPerInvestor"
              ]
                ? selectedUser["applicantData"]["questionnaires"][0][
                    "sections"
                  ]["documentsPerInvestor"]["items"]["selectInvestorType"][
                    "value"
                  ]
                : selectedUser &&
                    selectedUser["applicantData"]["questionnaires"] &&
                    selectedUser["applicantData"]["questionnaires"][1] &&
                    selectedUser["applicantData"]["questionnaires"][1][
                      "sections"
                    ]["documentsPerInvestor"]
                  ? selectedUser["applicantData"]["questionnaires"][1][
                      "sections"
                    ]["documentsPerInvestor"]["items"]["selectInvestorType"][
                      "value"
                    ]
                  : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Exter User Id</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["externalUserId"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Status On Sumsub</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["applicantStatus"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Status On Verified</b>
            </Col>
            <Col className="pl-0" xs={5}>
              {selectedUser ? selectedUser["statusText"] : ""}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col
              xs={{ span: 3, offset: 2 }}
              className="text-left d-flex flex-column gap-2"
            >
              <b>Applicant ID</b>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  const pdfTab = window.open("", "_blank");
                  pdfTab.document.write(
                    `<html>
  <head>
    <title>Applicant ID</title>
    <style>
      body {
        margin: 0;
        background: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
      }
      img {
        max-width: 90vw;
        max-height: 90vh;
        object-fit: contain;
      }
    </style>
  </head>
  <body>
    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
      <div class="justify-content-center align-items-center w-50 h-50">
          ${getBase64DisplayUrlTag(applicantDoc)?.html}
      </div>
    </div>
  </body>
</html>
`,
                  );
                  pdfTab.document.close();
                }}
                style={{ color: "blue" }}
                href="#"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open ID
              </a>

              <a
                href={getBase64DisplayUrl(applicantDoc)}
                style={{ color: "blue" }}
                download={`${selectedUser["fullName"]?.replaceAll(
                  " ",
                  "-",
                )}-Id.${getDownloadExt(applicantDoc)}`}
              >
                Download Image
              </a>
            </Col>
            <Col className="pl-0" xs={5}>
              {/* {applicantDoc &&
                getBase64DisplayUrlTag(applicantDoc, "200px", "180px")?.jsx} */}

              {applicantDoc && getFileSizeInMB(applicantDoc) > 5 && (
                <p>File is too large. Click Open File to view</p>
              )}
              {applicantDoc &&
                getFileSizeInMB(applicantDoc) <= 5 &&
                getBase64DisplayUrlTag(applicantDoc, "200px", "180px")?.jsx}
              {!applicantDoc && (
                <img
                  src=""
                  width="200px"
                  height="180px"
                  alt="Applicant's Document Loading..."
                />
              )}
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col
              xs={{ span: 3, offset: 2 }}
              className="text-left d-flex flex-column gap-2"
            >
              <b>Applicant Selfie</b>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  const pdfTab = window.open("", "_blank");
                  pdfTab.document.write(
                    `<html>
  <head>
    <title>Applicant Selfie</title>
    <style>
      body {
        margin: 0;
        background: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
      }
      img {
        max-width: 90vw;
        max-height: 90vh;
        object-fit: contain;
      }
    </style>
  </head>
  <body>
    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
      <div class="justify-content-center align-items-center w-50 h-50">
         ${getBase64DisplayUrlTag(applicantSelfie)?.html}
      </div>
    </div>
  </body>
</html>
`,
                  );
                  pdfTab.document.close();
                }}
                style={{ color: "blue" }}
                href="#"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Image
              </a>
            </Col>
            <Col className="pl-0" xs={5}>
              {applicantSelfie &&
                getBase64DisplayUrlTag(applicantSelfie, "150px", "100px")?.jsx}
              {!applicantSelfie && (
                <img
                  src=""
                  width="150px"
                  height="100px"
                  alt="Applicant's Selfie Loading..."
                />
              )}
            </Col>
          </Row>
          <hr />
          <b className="text-center w-100 mt-3">Verified Questionaire</b>
          {userDtLoading && (
            <b className="text-center w-100 mt-3">
              Verified Questionaire Loading...
            </b>
          )}
          {!userDtLoading && Object.keys(userDt)?.length <= 2 && (
            <b className="text-center w-100 mt-3">
              No Verified Questionaire Found
            </b>
          )}
          {!userDtLoading &&
            Object.keys(userDt)?.length > 4 &&
            Object.keys(userDt).map((key, idx, arr) => (
              <>
                {key?.toString() != "fcmToken" &&
                  key?.toString() != "hashedId" &&
                  key?.toString() != "passKeyRefHash" &&
                  key?.toString() != "lastLogin" &&
                  key?.toString() != "partnersDetails" && (
                    <>
                      {typeof userDt[key] === "string" &&
                        userDt[key]?.length > 0 &&
                        !userDt[key]?.toLowerCase()?.includes("document") && (
                          <Row
                            key={idx}
                            className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                          >
                            <Col
                              xs={{ span: 3, offset: 2 }}
                              className="text-left"
                            >
                              <p
                                style={{
                                  maxWidth: "90%",
                                  wordWrap: "break-word",
                                }}
                              >
                                {key}
                              </p>
                            </Col>
                            <Col className="pl-0" xs={5}>
                              <b>{userDt[key]}</b>
                            </Col>
                          </Row>
                        )}
                      {key === "taxResidency" &&
                        userDt[key]?.name?.length > 0 && (
                          <Row
                            key={idx}
                            className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                          >
                            <Col
                              xs={{ span: 3, offset: 2 }}
                              className="text-left"
                            >
                              <p
                                style={{
                                  maxWidth: "90%",
                                  wordWrap: "break-word",
                                }}
                              >
                                Tax Residency
                              </p>
                            </Col>
                            <Col className="pl-0" xs={5}>
                              <b>{userDt[key]?.name}</b>
                            </Col>
                          </Row>
                        )}
                      {key === "taxResidencySec" &&
                        userDt[key]?.name?.length > 0 && (
                          <Row
                            key={idx}
                            className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                          >
                            <Col
                              xs={{ span: 3, offset: 2 }}
                              className="text-left"
                            >
                              <p
                                style={{
                                  maxWidth: "90%",
                                  wordWrap: "break-word",
                                }}
                              >
                                Other Tax Residency
                              </p>
                            </Col>
                            <Col className="pl-0" xs={5}>
                              <b>{userDt[key]?.name}</b>
                            </Col>
                          </Row>
                        )}

                      {key === "registrationCountry" &&
                        userDt[key]?.name?.length > 0 && (
                          <Row
                            key={idx}
                            className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                          >
                            <Col
                              xs={{ span: 3, offset: 2 }}
                              className="text-left"
                            >
                              <p
                                style={{
                                  maxWidth: "90%",
                                  wordWrap: "break-word",
                                }}
                              >
                                Country Of Registration
                              </p>
                            </Col>
                            <Col className="pl-0" xs={5}>
                              <b>{userDt[key]?.name}</b>
                            </Col>
                          </Row>
                        )}

                      {typeof userDt[key] === "string" &&
                        userDt[key]?.length > 0 &&
                        userDt[key]?.toLowerCase()?.includes("document") && (
                          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                            <Col
                              xs={{ span: 3, offset: 2 }}
                              className="text-left d-flex flex-column gap-2"
                            >
                              <b
                                style={{
                                  maxWidth: "90%",
                                  wordWrap: "break-word",
                                }}
                              >
                                {key}
                              </b>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  const pdfTab = window.open("", "_blank");
                                  pdfTab.document.write(
                                    `
                         <html>
                            <head>
                              <title>
                                ${userDt[`${key + "Dt"}`]["name"]}
                              </title>
                            </head>
                            <body>
                              <iframe
                                width="100%"
                                height="100%"
                                src=${userDt[key]}
                                frameborder="0"
                              ></iframe>
                            </body>
                          </html></Row>
                         `,
                                  );
                                  pdfTab.document.close();
                                }}
                                style={{ color: "blue" }}
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open File
                              </a>
                            </Col>
                            {userDt[`${key + "Dt"}`] &&
                              userDt[`${key + "Dt"}`]["size"] && (
                                <Col className="pl-0" xs={5}>
                                  {check5MB(
                                    userDt[`${key + "Dt"}`]["size"] || 0,
                                  ) && (
                                    <p>
                                      File is too large. Click Open File to view
                                    </p>
                                  )}
                                  {!check5MB(
                                    userDt[`${key + "Dt"}`]["size"] || 0,
                                  ) && (
                                    <iframe
                                      src={userDt[key]}
                                      frameborder="0"
                                    ></iframe>
                                  )}
                                </Col>
                              )}

                            {!showChangeFile && (
                              <Col>
                                <Row
                                  className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                                  key={idx}
                                >
                                  <Col
                                    xs={{ span: 3, offset: 2 }}
                                    className="text-left"
                                  >
                                    <p style={{ color: "blue" }}>Change File</p>
                                  </Col>
                                  <Col className="pl-0" xs={5}>
                                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                                      <Col className="text-left">
                                        <input
                                          type="file"
                                          accept="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                                          id={key}
                                        />
                                      </Col>
                                      <Col className="text-left">
                                        <UiButton
                                          onClick={() => {
                                            const input =
                                              document.getElementById(key);
                                            let file;
                                            if (input) {
                                              file = input.files[0];
                                            }

                                            if (file?.name) {
                                              setFileToUpload(file);
                                              setShowChangeFile(true);
                                            } else {
                                              toast.error(
                                                "Invalid file selected.",
                                                ToastOptions,
                                              );
                                              setFileToUpload(null);
                                              setShowChangeFile(false);
                                            }
                                          }}
                                          buttonVariant="primary"
                                          buttonClass="SignUpButton flex-1 ml-0"
                                          buttonText="Proceed"
                                          type="submit"
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {showChangeFile && (
                              <Col
                                style={{
                                  minWidth: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "2px",
                                  padding: "2px",
                                  justifyContent: "center",
                                }}
                                className="pl-0"
                                xs={5}
                              >
                                <p style={{ color: "red" }}>
                                  You are about to change {key} file. Please
                                  note this action is irreversible, click Save
                                  New File only if previous file is downloaded.
                                </p>

                                <Row>
                                  <Col>
                                    <UiButton
                                      onClick={() => {
                                        setFileToUpload(null);
                                        setShowChangeFile(false);
                                        const input =
                                          document.getElementById(key);

                                        if (input) {
                                          input.files = [];
                                        }
                                      }}
                                      buttonClass="SignUpButton flex-1 ml-0"
                                      buttonVariant="secondary"
                                      buttonText="Cancel"
                                      type="submit"
                                    />
                                  </Col>
                                  <Col>
                                    <UiButton
                                      onClick={async () => {
                                        if (fileToUpload) {
                                          setLoader(true);
                                          const url =
                                            await uploadFileToFirebase(
                                              hashTheString(
                                                selectedUser["accountAddress"],
                                              ),
                                              fileToUpload,
                                              fileToUpload?.name,
                                            );

                                          if (url) {
                                            await saveKycQuestionnaire(
                                              account,

                                              hashTheString(
                                                selectedUser["accountAddress"],
                                              ),
                                              chainId,
                                              userSignature,

                                              {
                                                [key]:
                                                  await encryptKycString(url),
                                                [`${key}Dt`]: {
                                                  name: fileToUpload?.name,
                                                  size: fileToUpload?.size,
                                                },
                                              },
                                              userSignatureNonce,
                                            ).then(async (res) => {
                                              let userDtt;
                                              userDtt = await getUser(
                                                hashTheString(
                                                  selectedUser[
                                                    "accountAddress"
                                                  ],
                                                ),
                                                hashTheString(""),
                                              );

                                              userDtt = await getUser(
                                                hashTheString(
                                                  selectedUser[
                                                    "accountAddress"
                                                  ],
                                                ),
                                                hashTheString(""),
                                              );
                                              if (
                                                Object.keys(userDtt)?.length > 4
                                              ) {
                                                setUserDt(userDtt);
                                              }
                                              setFileToUpload(null);
                                              setShowChangeFile(false);
                                              setLoader(false);

                                              res
                                                ? toast.success(
                                                    `${key} file changed succesfully`,
                                                    ToastOptions,
                                                  )
                                                : toast.error(
                                                    "File change request failed",
                                                    ToastOptions,
                                                  );
                                            });
                                          }
                                          setLoader(false);
                                        }
                                      }}
                                      buttonVariant="primary"
                                      buttonClass="SignUpButton flex-1 ml-0"
                                      buttonText="Save New File"
                                      type="submit"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            )}
                          </Row>
                        )}

                      {userDt[key]?.length > 0 &&
                        Array.isArray(userDt[key]) && (
                          <React.Fragment>
                            {userDt[key]?.map((arrVal, idx) => (
                              <React.Fragment>
                                {arrVal?.length > 0 &&
                                  arrVal
                                    ?.toLowerCase()
                                    ?.includes("document") && (
                                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                                      <Col
                                        xs={{ span: 3, offset: 2 }}
                                        className="text-left d-flex flex-column gap-2"
                                      >
                                        <b
                                          style={{
                                            maxWidth: "90%",
                                            wordWrap: "break-word",
                                          }}
                                        >
                                          {key}
                                        </b>
                                        <a
                                          onClick={(e) => {
                                            e.preventDefault();
                                            const pdfTab = window.open(
                                              "",
                                              "_blank",
                                            );
                                            pdfTab.document.write(
                                              `
                         <html>
                            <head>
                              <title>
                                ${userDt[`${key + "Dt"}`][idx]["name"]}
                              </title>
                            </head>
                            <body>
                              <iframe
                                width="100%"
                                height="100%"
                                src=${arrVal}
                                frameborder="0"
                              ></iframe>
                            </body>
                          </html></Row>
                         `,
                                            );
                                            pdfTab.document.close();
                                          }}
                                          style={{ color: "blue" }}
                                          href="#"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Open File
                                        </a>
                                      </Col>
                                      {userDt[`${key + "Dt"}`] &&
                                        userDt[`${key + "Dt"}`][idx] &&
                                        userDt[`${key + "Dt"}`][idx][
                                          "size"
                                        ] && (
                                          <Col className="pl-0" xs={5}>
                                            {check5MB(
                                              userDt[`${key + "Dt"}`][idx][
                                                "size"
                                              ] || 0,
                                            ) && (
                                              <p>
                                                File is too large. Click Open
                                                File to view
                                              </p>
                                            )}
                                            {!check5MB(
                                              userDt[`${key + "Dt"}`][idx][
                                                "size"
                                              ],
                                            ) && (
                                              <iframe
                                                src={arrVal}
                                                frameborder="0"
                                              ></iframe>
                                            )}
                                          </Col>
                                        )}
                                      {!showChangeFile && (
                                        <Col>
                                          <Row
                                            className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                                            key={idx}
                                          >
                                            <Col
                                              xs={{ span: 3, offset: 2 }}
                                              className="text-left"
                                            >
                                              <p style={{ color: "blue" }}>
                                                Change File
                                              </p>
                                            </Col>
                                            <Col className="pl-0" xs={5}>
                                              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                                                <Col className="text-left">
                                                  <input
                                                    type="file"
                                                    accept="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                                                    id={`${key}-${idx}`}
                                                  />
                                                </Col>
                                                <Col className="text-left">
                                                  <UiButton
                                                    onClick={() => {
                                                      const input =
                                                        document.getElementById(
                                                          `${key}-${idx}`,
                                                        );
                                                      let file;
                                                      if (input) {
                                                        file = input.files[0];
                                                      }

                                                      if (file?.name) {
                                                        setFileToUpload(file);
                                                        setShowChangeFile(true);
                                                      } else {
                                                        toast.error(
                                                          "Invalid file selected.",
                                                          ToastOptions,
                                                        );
                                                        setFileToUpload(null);
                                                        setShowChangeFile(
                                                          false,
                                                        );
                                                      }
                                                    }}
                                                    buttonVariant="primary"
                                                    buttonClass="SignUpButton flex-1 ml-0"
                                                    buttonText="Proceed"
                                                    type="submit"
                                                  />
                                                </Col>
                                              </Row>
                                            </Col>
                                          </Row>
                                        </Col>
                                      )}
                                      {showChangeFile && (
                                        <Col
                                          style={{
                                            minWidth: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "2px",
                                            padding: "2px",
                                            justifyContent: "center",
                                          }}
                                          className="pl-0"
                                          xs={5}
                                        >
                                          <p style={{ color: "red" }}>
                                            You are about to change {key} file.
                                            Please note this action is
                                            irreversible, click Save New File
                                            only if previous file is downloaded.
                                          </p>

                                          <Row>
                                            <Col>
                                              <UiButton
                                                onClick={() => {
                                                  setFileToUpload(null);
                                                  setShowChangeFile(false);
                                                  const input =
                                                    document.getElementById(
                                                      `${key}-${idx}`,
                                                    );

                                                  if (input) {
                                                    input.files = [];
                                                  }
                                                }}
                                                buttonClass="SignUpButton flex-1 ml-0"
                                                buttonVariant="secondary"
                                                buttonText="Cancel"
                                                type="submit"
                                              />
                                            </Col>
                                            <Col>
                                              <UiButton
                                                onClick={async () => {
                                                  if (fileToUpload) {
                                                    setLoader(true);
                                                    const url =
                                                      await uploadFileToFirebase(
                                                        hashTheString(
                                                          selectedUser[
                                                            "accountAddress"
                                                          ],
                                                        ),
                                                        fileToUpload,
                                                        fileToUpload?.name,
                                                      );

                                                    if (url) {
                                                      let newKey = userDt[key];

                                                      newKey[idx] =
                                                        await encryptKycString(
                                                          url,
                                                        );
                                                      let newKeyDt =
                                                        userDt[`${key}Dt`];
                                                      newKeyDt[idx] = {
                                                        name: fileToUpload?.name,
                                                        size: fileToUpload?.size,
                                                      };
                                                      await saveKycQuestionnaire(
                                                        account,

                                                        hashTheString(
                                                          selectedUser[
                                                            "accountAddress"
                                                          ],
                                                        ),
                                                        chainId,
                                                        userSignature,

                                                        {
                                                          [key]: newKey,
                                                          [`${key}Dt`]:
                                                            newKeyDt,
                                                        },
                                                        userSignatureNonce,
                                                      ).then(async (res) => {
                                                        let userDtt;
                                                        userDtt = await getUser(
                                                          hashTheString(
                                                            selectedUser[
                                                              "accountAddress"
                                                            ],
                                                          ),
                                                          hashTheString(""),
                                                        );

                                                        userDtt = await getUser(
                                                          hashTheString(
                                                            selectedUser[
                                                              "accountAddress"
                                                            ],
                                                          ),
                                                          hashTheString(""),
                                                        );
                                                        if (
                                                          Object.keys(userDtt)
                                                            ?.length > 4
                                                        ) {
                                                          setUserDt(userDtt);
                                                        }
                                                        setFileToUpload(null);
                                                        setShowChangeFile(
                                                          false,
                                                        );
                                                        setLoader(false);

                                                        res
                                                          ? toast.success(
                                                              `${key} file changed succesfully`,
                                                              ToastOptions,
                                                            )
                                                          : toast.error(
                                                              "File change request failed",
                                                              ToastOptions,
                                                            );
                                                      });
                                                    }
                                                    setLoader(false);
                                                  }
                                                }}
                                                buttonVariant="primary"
                                                buttonClass="SignUpButton flex-1 ml-0"
                                                buttonText="Save New File"
                                                type="submit"
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      )}
                                    </Row>
                                  )}
                              </React.Fragment>
                            ))}
                          </React.Fragment>
                        )}
                    </>
                  )}
              </>
            ))}
          <hr />
          <b className="text-center w-100 mt-3">Other Companies In Structure</b>
          {userDtLoading && (
            <b className="text-center w-100 mt-3">
              Other Companies In Structure Loading...
            </b>
          )}
          {!userDtLoading && Object.keys(userDt)?.length <= 2 && (
            <b className="text-center w-100 mt-3">
              No Other Companies In Structure
            </b>
          )}
          {!userDtLoading &&
            userDt["partnersDetails"] &&
            userDt["partnersDetails"]?.length > 0 && (
              <React.Fragment>
                {userDt["partnersDetails"]?.map((partner, idx) => (
                  <React.Fragment>
                    <b className="text-center w-100 mt-3">
                      Company In Structure {idx + 1}
                    </b>
                    {Object.keys(partner).map((key, idx, arr) => (
                      <React.Fragment>
                        {typeof partner[key] === "string" &&
                          partner[key]?.length > 0 &&
                          !partner[key]
                            ?.toLowerCase()
                            ?.includes("document") && (
                            <Row
                              key={idx}
                              className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                            >
                              <Col
                                xs={{ span: 3, offset: 2 }}
                                className="text-left"
                              >
                                <p
                                  style={{
                                    maxWidth: "90%",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {key}
                                </p>
                              </Col>
                              <Col className="pl-0" xs={5}>
                                <b>{partner[key]}</b>
                              </Col>
                            </Row>
                          )}

                        {key === "partnerSelectedCountryInc" &&
                          partner[key]?.name?.length > 0 && (
                            <Row
                              key={idx}
                              className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                            >
                              <Col
                                xs={{ span: 3, offset: 2 }}
                                className="text-left"
                              >
                                <p
                                  style={{
                                    maxWidth: "90%",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  Country Of Registration
                                </p>
                              </Col>
                              <Col className="pl-0" xs={5}>
                                <b>{partner[key]?.name}</b>
                              </Col>
                            </Row>
                          )}

                        {typeof partner[key] === "string" &&
                          partner[key]?.length > 0 &&
                          partner[key]?.toLowerCase()?.includes("document") && (
                            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                              <Col
                                xs={{ span: 3, offset: 2 }}
                                className="text-left d-flex flex-column gap-2"
                              >
                                <b
                                  style={{
                                    maxWidth: "90%",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {key}
                                </b>
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    const pdfTab = window.open("", "_blank");
                                    pdfTab.document.write(
                                      `
                         <html>
                            <head>
                              <title>
                                ${partner[`${key + "Dt"}`]["name"]}
                              </title>
                            </head>
                            <body>
                              <iframe
                                width="100%"
                                height="100%"
                                src=${partner[key]}
                                frameborder="0"
                              ></iframe>
                            </body>
                          </html></Row>
                         `,
                                    );
                                    pdfTab.document.close();
                                  }}
                                  style={{ color: "blue" }}
                                  href="#"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Open File
                                </a>
                              </Col>
                              {partner[`${key + "Dt"}`] &&
                                partner[`${key + "Dt"}`]["size"] && (
                                  <Col className="pl-0" xs={5}>
                                    {check5MB(
                                      partner[`${key + "Dt"}`]["size"] || 0,
                                    ) && (
                                      <p>
                                        File is too large. Click Open File to
                                        view
                                      </p>
                                    )}
                                    {!check5MB(
                                      partner[`${key + "Dt"}`]["size"] || 0,
                                    ) && (
                                      <iframe
                                        src={partner[key]}
                                        frameborder="0"
                                      ></iframe>
                                    )}
                                  </Col>
                                )}
                              {!showChangeFile && (
                                <Col>
                                  <Row
                                    className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                                    key={idx}
                                  >
                                    <Col
                                      xs={{ span: 3, offset: 2 }}
                                      className="text-left"
                                    >
                                      <p style={{ color: "blue" }}>
                                        Change File
                                      </p>
                                    </Col>
                                    <Col className="pl-0" xs={5}>
                                      <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                                        <Col className="text-left">
                                          <input
                                            type="file"
                                            accept="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                                            id={key}
                                          />
                                        </Col>
                                        <Col className="text-left">
                                          <UiButton
                                            onClick={() => {
                                              const input =
                                                document.getElementById(key);
                                              let file;
                                              if (input) {
                                                file = input.files[0];
                                              }

                                              if (file?.name) {
                                                setFileToUpload(file);
                                                setShowChangeFile(true);
                                              } else {
                                                toast.error(
                                                  "Invalid file selected.",
                                                  ToastOptions,
                                                );
                                                setFileToUpload(null);
                                                setShowChangeFile(false);
                                              }
                                            }}
                                            buttonVariant="primary"
                                            buttonClass="SignUpButton flex-1 ml-0"
                                            buttonText="Proceed"
                                            type="submit"
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                              {showChangeFile && (
                                <Col
                                  style={{
                                    minWidth: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "2px",
                                    padding: "2px",
                                    justifyContent: "center",
                                  }}
                                  className="pl-0"
                                  xs={5}
                                >
                                  <p style={{ color: "red" }}>
                                    You are about to change {key} file. Please
                                    note this action is irreversible, click Save
                                    New File only if previous file is
                                    downloaded.
                                  </p>

                                  <Row>
                                    <Col>
                                      <UiButton
                                        onClick={() => {
                                          setFileToUpload(null);
                                          setShowChangeFile(false);
                                          const input =
                                            document.getElementById(key);

                                          if (input) {
                                            input.files = [];
                                          }
                                        }}
                                        buttonClass="SignUpButton flex-1 ml-0"
                                        buttonVariant="secondary"
                                        buttonText="Cancel"
                                        type="submit"
                                      />
                                    </Col>
                                    <Col>
                                      <UiButton
                                        onClick={async () => {
                                          if (fileToUpload) {
                                            setLoader(true);
                                            const url =
                                              await uploadFileToFirebase(
                                                hashTheString(
                                                  selectedUser[
                                                    "accountAddress"
                                                  ],
                                                ),
                                                fileToUpload,
                                                fileToUpload?.name,
                                              );

                                            if (url) {
                                              await saveKycQuestionnaire(
                                                account,

                                                hashTheString(
                                                  selectedUser[
                                                    "accountAddress"
                                                  ],
                                                ),
                                                chainId,
                                                userSignature,

                                                {
                                                  [key]:
                                                    await encryptKycString(url),
                                                  [`${key}Dt`]: {
                                                    name: fileToUpload?.name,
                                                    size: fileToUpload?.size,
                                                  },
                                                },
                                                userSignatureNonce,
                                              ).then(async (res) => {
                                                let userDtt;
                                                userDtt = await getUser(
                                                  hashTheString(
                                                    selectedUser[
                                                      "accountAddress"
                                                    ],
                                                  ),
                                                  hashTheString(""),
                                                );

                                                userDtt = await getUser(
                                                  hashTheString(
                                                    selectedUser[
                                                      "accountAddress"
                                                    ],
                                                  ),
                                                  hashTheString(""),
                                                );
                                                if (
                                                  Object.keys(userDtt)?.length >
                                                  4
                                                ) {
                                                  setUserDt(userDtt);
                                                }
                                                setFileToUpload(null);
                                                setShowChangeFile(false);
                                                setLoader(false);

                                                res
                                                  ? toast.success(
                                                      `${key} file changed succesfully`,
                                                      ToastOptions,
                                                    )
                                                  : toast.error(
                                                      "File change request failed",
                                                      ToastOptions,
                                                    );
                                              });
                                            }
                                            setLoader(false);
                                          }
                                        }}
                                        buttonVariant="primary"
                                        buttonClass="SignUpButton flex-1 ml-0"
                                        buttonText="Save New File"
                                        type="submit"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                            </Row>
                          )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            )}
          <hr />
          {selectedUser &&
            selectedUser["applicantData"]["questionnaires"] &&
            selectedUser["applicantData"]["questionnaires"][0] &&
            selectedUser["applicantData"]["questionnaires"][0]["sections"][
              "institutionalCustody"
            ] && (
              <b className="text-center w-100 mt-3">
                Instituitional Custody Questionaire
              </b>
            )}

          {selectedUser &&
            selectedUser["applicantData"]["questionnaires"] &&
            selectedUser["applicantData"]["questionnaires"][0] &&
            selectedUser["applicantData"]["questionnaires"][0]["sections"][
              "institutionalCustody"
            ] &&
            Object.keys(
              selectedUser["applicantData"]["questionnaires"][0]["sections"][
                "institutionalCustody"
              ]["items"],
            ).map((key, idx, arr) => (
              <>
                {selectedUser["applicantData"]["questionnaires"][0]["sections"][
                  "institutionalCustody"
                ]["items"][`${key}`]["value"] && (
                  <Row
                    key={idx}
                    className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                  >
                    <Col xs={{ span: 3, offset: 2 }} className="text-left">
                      <p style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                        {key}
                      </p>
                    </Col>
                    <Col className="pl-0" xs={5}>
                      <b>
                        {
                          selectedUser["applicantData"]["questionnaires"][0][
                            "sections"
                          ]["institutionalCustody"]["items"][`${key}`]["value"]
                        }
                      </b>
                    </Col>
                  </Row>
                )}
              </>
            ))}

          <b className="text-center w-100 mt-3">Basic Sumsub Questionnaire</b>
          {selectedUser &&
            selectedUser["applicantData"]["questionnaires"] &&
            selectedUser["applicantData"]["questionnaires"][0] &&
            selectedUser["applicantData"]["questionnaires"][0]["sections"][
              "individualInvestorTy"
            ] &&
            Object.keys(
              selectedUser["applicantData"]["questionnaires"][0]["sections"][
                "individualInvestorTy"
              ]["items"],
            ).map((key, idx, arr) => (
              <>
                {selectedUser["applicantData"]["questionnaires"][0]["sections"][
                  "individualInvestorTy"
                ]["items"][`${key}`]["value"] && (
                  <Row
                    key={idx}
                    className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                  >
                    <Col xs={{ span: 3, offset: 2 }} className="text-left">
                      <p style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                        {key}
                      </p>
                    </Col>
                    <Col className="pl-0" xs={5}>
                      <b>
                        {
                          selectedUser["applicantData"]["questionnaires"][0][
                            "sections"
                          ]["individualInvestorTy"]["items"][`${key}`]["value"]
                        }
                      </b>
                    </Col>
                  </Row>
                )}
              </>
            ))}
          <hr />

          {selectedUser &&
            selectedUser["applicantData"]["questionnaires"] &&
            selectedUser["applicantData"]["questionnaires"][1] &&
            selectedUser["applicantData"]["questionnaires"][1]["sections"][
              "individualInvestorTy"
            ] &&
            Object.keys(
              selectedUser["applicantData"]["questionnaires"][1]["sections"][
                "individualInvestorTy"
              ]["items"],
            ).map((key, idx, arr) => (
              <>
                {selectedUser["applicantData"]["questionnaires"][1]["sections"][
                  "individualInvestorTy"
                ]["items"][`${key}`]["value"] && (
                  <Row
                    key={idx}
                    className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                  >
                    <Col xs={{ span: 3, offset: 2 }} className="text-left">
                      <p style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                        {key}
                      </p>
                    </Col>
                    <Col className="pl-0" xs={5}>
                      <b>
                        {
                          selectedUser["applicantData"]["questionnaires"][1][
                            "sections"
                          ]["individualInvestorTy"]["items"][`${key}`]["value"]
                        }
                      </b>
                    </Col>
                  </Row>
                )}
              </>
            ))}
          <hr />
          <b className="text-center w-100 mt-3">
            Additional Sumsub Questionaire
          </b>
          {selectedUser &&
            selectedUser["applicantData"]["questionnaires"] &&
            selectedUser["applicantData"]["questionnaires"][0] &&
            selectedUser["applicantData"]["questionnaires"][0]["sections"][
              "documentsPerInvestor"
            ] &&
            Object.keys(
              selectedUser["applicantData"]["questionnaires"][0]["sections"][
                "documentsPerInvestor"
              ]["items"],
            ).map((key, idx, arr) => (
              <>
                {selectedUser["applicantData"]["questionnaires"][0]["sections"][
                  "documentsPerInvestor"
                ]["items"][`${key}`]["value"] && (
                  <Row
                    key={idx}
                    className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                  >
                    <Col xs={{ span: 3, offset: 2 }} className="text-left">
                      <p style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                        {key}
                      </p>
                    </Col>
                    <Col className="pl-0" xs={5}>
                      <b>
                        {
                          selectedUser["applicantData"]["questionnaires"][0][
                            "sections"
                          ]["documentsPerInvestor"]["items"][`${key}`]["value"]
                        }
                      </b>
                    </Col>
                  </Row>
                )}
              </>
            ))}

          {selectedUser &&
            selectedUser["applicantData"]["questionnaires"] &&
            selectedUser["applicantData"]["questionnaires"][1] &&
            selectedUser["applicantData"]["questionnaires"][1]["sections"][
              "documentsPerInvestor"
            ] &&
            Object.keys(
              selectedUser["applicantData"]["questionnaires"][1]["sections"][
                "documentsPerInvestor"
              ]["items"],
            ).map((key, idx, arr) => (
              <>
                {selectedUser["applicantData"]["questionnaires"][1]["sections"][
                  "documentsPerInvestor"
                ]["items"][`${key}`]["value"] && (
                  <Row
                    key={idx}
                    className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center"
                  >
                    <Col xs={{ span: 3, offset: 2 }} className="text-left">
                      <p style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                        {key}
                      </p>
                    </Col>
                    <Col className="pl-0" xs={5}>
                      <b>
                        {
                          selectedUser["applicantData"]["questionnaires"][1][
                            "sections"
                          ]["documentsPerInvestor"]["items"][`${key}`]["value"]
                        }
                      </b>
                    </Col>
                  </Row>
                )}
              </>
            ))}

          <hr />
          {!questionaireDocsLoading && !applicantQuestionnaireDocs && (
            <b className="text-center w-100 mt-3">
              No Sumsub Questionaire Document Found
            </b>
          )}
          {!questionaireDocsLoading && applicantQuestionnaireDocs && (
            <b className="text-center w-100 mt-3">
              Sumsub Questionaire Documents
            </b>
          )}
          {questionaireDocsLoading && (
            <b className="text-center w-100 mt-3">
              Sumsub Questionaire Documents Loading May Take Some Time...
            </b>
          )}

          {applicantQuestionnaireDocs && (
            <>
              {applicantQuestionnaireDocs.aml && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Certified AML policy and procedures of the company /
                      Original AML letter
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Certified AML policy and procedures of the
                                company / Original AML letter
                              </title>
                            </head>
                            <body>
                              ${
                                getBase64DisplayUrlTag(
                                  applicantQuestionnaireDocs.aml,
                                )?.html
                              }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(applicantQuestionnaireDocs.aml) > 5 && (
                      <p>File is too large. Click Open File to view</p>
                    )}
                    {getFileSizeInMB(applicantQuestionnaireDocs.aml) <= 5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.aml,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.ownership && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    cl
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Ownership and Control Structure Chart
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Ownership and Control Structure Chart
                              </title>
                            </head>
                            <body>
                              ${
                                getBase64DisplayUrlTag(
                                  applicantQuestionnaireDocs.ownership,
                                )?.html
                              }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(applicantQuestionnaireDocs.ownership) >
                      5 && <p>File is too large. Click Open File to view</p>}
                    {getFileSizeInMB(applicantQuestionnaireDocs.ownership) <=
                      5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.ownership,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.articles.length > 0 && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Articles and / or Memorandum of Association
                    </b>

                    {applicantQuestionnaireDocs.articles.map((art) => (
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          const pdfTab = window.open("", "_blank");
                          pdfTab.document.write(
                            `
                       <html>
                          <head>
                            <title>
                              Articles and / or Memorandum of Association
                            </title>
                          </head>
                          <body>
                            ${getBase64DisplayUrlTag(art)?.html}
                          </body>
                        </html></Row>
                       `,
                          );
                          pdfTab.document.close();
                        }}
                        style={{ color: "blue" }}
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open File
                      </a>
                    ))}
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {applicantQuestionnaireDocs.articles.map((art, idx) => (
                      <>
                        {getFileSizeInMB(art) > 5 && (
                          <p>File is too large. Click Open File to view</p>
                        )}
                        {getFileSizeInMB(art) <= 5 && (
                          <iframe
                            key={idx}
                            src={getBase64DisplayUrl(art)}
                            frameborder="0"
                          ></iframe>
                        )}
                      </>
                    ))}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.fatca && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      FATCA-CRS-Self-Certification form for Controlling Person
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                FATCA-CRS-Self-Certification form for Controlling Person
                              </title>
                            </head>
                            <body>
                              ${
                                getBase64DisplayUrlTag(
                                  applicantQuestionnaireDocs.fatca,
                                )?.html
                              }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(applicantQuestionnaireDocs.fatca) > 5 && (
                      <p>File is too large. Click Open File to view</p>
                    )}
                    {getFileSizeInMB(applicantQuestionnaireDocs.fatca) <= 5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.fatca,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.annualReports.length > 0 && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Latest audited annual report/financial statements
                    </b>
                    {applicantQuestionnaireDocs.annualReports.map((rpt) => (
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          const pdfTab = window.open("", "_blank");
                          pdfTab.document.write(
                            `
                       <html>
                          <head>
                            <title>
                              Latest audited annual report/financial statements
                            </title>
                          </head>
                          <body>
                            ${getBase64DisplayUrlTag(rpt)?.html}
                          </body>
                        </html></Row>
                       `,
                          );
                          pdfTab.document.close();
                        }}
                        style={{ color: "blue" }}
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open File
                      </a>
                    ))}
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {applicantQuestionnaireDocs.annualReports.map(
                      (report, idx) => (
                        <>
                          {getFileSizeInMB(report) > 5 && (
                            <p>File is too large. Click Open File to view</p>
                          )}
                          {getFileSizeInMB(report) <= 5 && (
                            <iframe
                              key={idx}
                              src={getBase64DisplayUrl(report)}
                              frameborder="0"
                            ></iframe>
                          )}
                        </>
                      ),
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.certifiedIds.length > 0 && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Certified and Valid IDs of the Directors / Authorised
                      signatories / Beneficial Owners / Controlling Persons
                    </b>

                    {applicantQuestionnaireDocs.certifiedIds.map((cnt) => (
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          const pdfTab = window.open("", "_blank");
                          pdfTab.document.write(
                            `
                         <html>
                            <head>
                              <title>
                                Certified and Valid IDs of the Directors / Authorised
                                signatories / Beneficial Owners / Controlling Persons
                              </title>
                            </head>
                            <body>
                             ${getBase64DisplayUrlTag(cnt)?.html}
                            </body>
                          </html></Row>
                         `,
                          );
                          pdfTab.document.close();
                        }}
                        style={{ color: "blue" }}
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open File
                      </a>
                    ))}
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {applicantQuestionnaireDocs.certifiedIds.map((cnt) => (
                      <>
                        {getFileSizeInMB(cnt) > 5 && (
                          <p>File is too large. Click Open File to view</p>
                        )}
                        {getFileSizeInMB(cnt) <= 5 && (
                          <iframe
                            src={getBase64DisplayUrl(cnt)}
                            frameborder="0"
                          ></iframe>
                        )}
                      </>
                    ))}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.formW8B && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Form W-8BEN-E
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Form W-8BEN-E
                              </title>
                            </head>
                            <body>
                            ${
                              getBase64DisplayUrlTag(
                                applicantQuestionnaireDocs.formW8B,
                              )?.html
                            }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(applicantQuestionnaireDocs.formW8B) >
                      5 && <p>File is too large. Click Open File to view</p>}
                    {getFileSizeInMB(applicantQuestionnaireDocs.formW8B) <=
                      5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.formW8B,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.beneficiary && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Ultimate Beneficial Owner (UBO) Declaration (If any)
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Ultimate Beneficial Owner (UBO) Declaration (If any)
                              </title>
                            </head>
                            <body>
                              ${
                                getBase64DisplayUrlTag(
                                  applicantQuestionnaireDocs.beneficiary,
                                )?.html
                              }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(applicantQuestionnaireDocs.beneficiary) >
                      5 && <p>File is too large. Click Open File to view</p>}
                    {getFileSizeInMB(applicantQuestionnaireDocs.beneficiary) <=
                      5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.beneficiary,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.regulation && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Proof of regulation
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Proof of regulation
                              </title>
                            </head>
                            <body>
                               ${
                                 getBase64DisplayUrlTag(
                                   applicantQuestionnaireDocs.regulation,
                                 )?.html
                               }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(applicantQuestionnaireDocs.regulation) >
                      5 && <p>File is too large. Click Open File to view</p>}
                    {getFileSizeInMB(applicantQuestionnaireDocs.regulation) <=
                      5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.regulation,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.registerOfDirectors && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Register of Directors
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Register of Directors
                              </title>
                            </head>
                            <body>
                             ${
                               getBase64DisplayUrlTag(
                                 applicantQuestionnaireDocs.registerOfDirectors,
                               )?.html
                             }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(
                      applicantQuestionnaireDocs.registerOfDirectors,
                    ) > 5 && <p>File is too large. Click Open File to view</p>}
                    {getFileSizeInMB(
                      applicantQuestionnaireDocs.registerOfDirectors,
                    ) <= 5 && (
                      <iframe
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.registerOfDirectors,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}

              {applicantQuestionnaireDocs.authorisedSignatory && (
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col
                    xs={{ span: 3, offset: 2 }}
                    className="text-left d-flex flex-column gap-2"
                  >
                    <b style={{ maxWidth: "90%", wordWrap: "break-word" }}>
                      Authorised Signatory List
                    </b>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        const pdfTab = window.open("", "_blank");
                        pdfTab.document.write(
                          `
                         <html>
                            <head>
                              <title>
                                Authorised Signatory List
                              </title>
                            </head>
                            <body>
                              ${
                                getBase64DisplayUrlTag(
                                  applicantQuestionnaireDocs.authorisedSignatory,
                                )?.html
                              }
                            </body>
                          </html></Row>
                         `,
                        );
                        pdfTab.document.close();
                      }}
                      style={{ color: "blue" }}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open File
                    </a>
                  </Col>
                  <Col className="pl-0" xs={5}>
                    {getFileSizeInMB(
                      applicantQuestionnaireDocs.authorisedSignatory,
                    ) > 5 && <p>File is too large. Click Open File to view</p>}
                    {getFileSizeInMB(
                      applicantQuestionnaireDocs.authorisedSignatory,
                    ) <= 5 && (
                      <iframe
                        id="ss"
                        src={getBase64DisplayUrl(
                          applicantQuestionnaireDocs.authorisedSignatory,
                        )}
                        frameborder="0"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              )}
            </>
          )}

          <hr />
          <b className="text-center w-100 mt-3">Rejection Reasons</b>
          {selectedUser?.rejectionData?.list?.items &&
            selectedUser?.rejectionData?.list?.items[0] &&
            selectedUser?.rejectionData?.list?.items[0]?.applicantState && (
              <>
                {Object.keys(
                  selectedUser?.rejectionData?.list?.items[0]?.applicantState,
                )?.map((key) => (
                  <>
                    {selectedUser?.rejectionData?.list?.items[0]
                      ?.applicantState[key]?.value && (
                      <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                        <Col xs={{ span: 3, offset: 2 }} className="text-left">
                          <p style={{ color: "red", minWidth: "max-content" }}>
                            {sumsubRejectionReasonsObj[key?.toString()]
                              ? sumsubRejectionReasonsObj[key]
                              : key?.toString()}
                          </p>
                        </Col>
                      </Row>
                    )}
                  </>
                ))}

                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  {newLink?.length > 0 && (
                    <Col className="pl-0">
                      <a
                        href={newLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        New Verification Link
                      </a>
                    </Col>
                  )}
                  <Col className="pl-0">
                    {newLink?.length === 0 && (
                      <UiButton
                        onClick={async () => {
                          setLoader(true);
                          const newLinkObj = await fixApplicantRejections(
                            selectedUser["applicantId"],
                            selectedUser["externalUserId"],
                            selectedUser?.rejectionData?.list?.items[0]
                              ?.applicantState,
                          );

                          if (newLinkObj?.link?.length > 0) {
                            setNewLink(newLinkObj?.link);
                            toast.success(
                              "New Verification Link Created",
                              ToastOptions,
                            );
                          } else {
                            toast.error(
                              "Fix Restriction failed.",
                              ToastOptions,
                            );
                            if (newLinkObj?.isDuplicate) {
                              setIsDuplicate(true);
                            }
                          }
                          setUniqueRejections(newLinkObj?.uniqueReset);
                          setLoader(false);
                        }}
                        buttonVariant="primary"
                        buttonClass="SignUpButton flex-1 ml-0"
                        buttonText="Fix Applicant Rejections"
                        type="submit"
                      />
                    )}

                    {newLink?.length > 0 && (
                      <UiButton
                        onClick={async () => {
                          setLoader(true);
                          await sendMessageToApplicant(
                            selectedUser["email"],
                            selectedUser["firstName"],
                            "Verified Network KYC Verification Result",
                            `${newLink}--${uniqueRejections?.join(",")}`,
                            "kyc_reverify",
                          ).then((res) => {
                            setLoader(false);
                            res
                              ? toast.success(
                                  "Message sent succesfully",
                                  ToastOptions,
                                )
                              : toast.error(
                                  "Error while sending message",
                                  ToastOptions,
                                );
                            if (res) {
                              handleModalHide();
                            }
                          });
                        }}
                        buttonVariant="primary"
                        buttonClass="SignUpButton flex-1 ml-0"
                        buttonText="Send Link To User"
                        type="submit"
                      />
                    )}
                  </Col>
                </Row>
              </>
            )}
        </Row>
      </div>
    );
  } else if (modalView === 7) {
    heading = `Filter Applicants By ${filterType}`;
    message = (
      <Row className="ml-1 align-items-center">
        <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
          <Col xs={{ span: 3, offset: 2 }} className="text-left">
            {filterType.toLowerCase() === "name" && <b>Name</b>}
            {filterType.toLowerCase() === "status" && <b>Status</b>}
            {filterType.toLowerCase() === "date" && <b>From Date</b>}
          </Col>
          <Col className="pl-0" xs={5}>
            {filterType.toLowerCase() === "name" && (
              <TextInput
                placeholder="Applicant name"
                onChange={(e) => setFilterContent(e.target.value)}
                value={filterContent}
              />
            )}
            {filterType.toLowerCase() === "status" && (
              <Select
                options={[
                  {
                    value: "1",
                    label: "1 (Pending)",
                  },
                  {
                    value: "2",
                    label: "2 (Rejected)",
                  },
                  // {
                  //   value: "3",
                  //   label: "3 (Accepted)",
                  // },
                ]}
                isMulti={false}
                value={filterContent}
                onChange={(selected) => {
                  setFilterContent(selected);
                }}
              />
            )}
            {filterType.toLowerCase() === "date" && (
              <DateTimePicker onChange={onChange} value={value} />
            )}
          </Col>
        </Row>
        {filterType.toLowerCase() === "date" && (
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>To Date</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DateTimePicker onChange={onChange2} value={value2} />
            </Col>
          </Row>
        )}

        <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
          <Col className="pl-0">
            <UiButton
              onClick={async () => {
                if (filterType.toLowerCase() === "name") {
                  const newData = processedData?.filter((data) => {
                    if (
                      data &&
                      data.fullName
                        .toLowerCase()
                        .includes(filterContent.toLowerCase())
                    ) {
                      return data;
                    }
                  });
                  setNewData(newData);
                }
                if (filterType.toLowerCase() === "date") {
                  const newData = processedData?.filter((data) => {
                    if (
                      data &&
                      Number(data.createdTimeRaw) >=
                        Number(Math.floor(value.getTime() / 1000)) &&
                      Number(data.createdTimeRaw) <=
                        Number(Math.floor(value2.getTime() / 1000))
                    ) {
                      return data;
                    }
                  });

                  setNewData(newData);
                }
                if (filterType.toLowerCase() === "status") {
                  const newData = processedData?.filter((data) => {
                    if (
                      data &&
                      Number(data.status) === Number(filterContent.value)
                    ) {
                      return data;
                    }
                  });

                  setNewData(newData);
                }
                setShowModal(false);
                setModalView(0);
                setFilterContent(null);
              }}
              buttonVariant="primary"
              buttonClass="SignUpButton flex-1 ml-0"
              buttonText="Filter"
              type="submit"
            />
          </Col>
        </Row>
      </Row>
    );
  } else if (modalView === 8) {
    heading = "Approve Applicant";
    message = (
      <>
        {loader ? <Loader /> : null}
        <div className="d-grid gap-2">
          {changeContent && (
            <>
              <p>{kycTexts.approved}</p>
              <UiButton
                onClick={() => {
                  handleModalHide();
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Click to close this form&nbsp;&rarr;"
                type="submit"
              />
            </>
          )}
          {!changeContent && (
            <Row className="ml-1 align-items-center">
              <b>You are about to Approve:</b>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Id</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["applicantId"] : ""}
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Name</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["name"] : ""}
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Email</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["email"] : ""}
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Country</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["countryName"] : ""}
                </Col>
              </Row>

              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col className="pl-0">
                  <UiButton
                    onClick={async () => {
                      if (chainId) {
                        setLoader(true);
                        const abiCoder = new ethers.utils.AbiCoder();
                        await approveOrRejectApplicant(
                          selectedUser["applicantId"],
                          selectedUser["inspectionId"],
                          abiCoder.encode(
                            ["string", "string"],
                            [
                              selectedUser["id"],
                              selectedUser["id"]?.toLowerCase() !==
                              selectedUser["accountAddress"]?.toLowerCase()
                                ? `${
                                    String(selectedUser["acctChain"]) +
                                    "-" +
                                    selectedUser["accountAddress"]
                                  }`
                                : String(chainId),
                            ],
                          ),
                          {
                            reviewAnswer: "GREEN",
                          },
                        ).then((res) => {
                          setLoader(false);
                          if (res) {
                            toast.success(
                              "Applicant Approved Succesfully",
                              ToastOptions,
                            );
                            setChangeContent(true);
                          } else {
                            toast.error(
                              "Applicant Approval Failed",
                              ToastOptions,
                            );
                          }
                        });
                      }
                    }}
                    buttonVariant="danger"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText="Approve Applicant"
                    type="submit"
                  />
                </Col>
              </Row>
            </Row>
          )}
        </div>
      </>
    );
  } else if (modalView === 9) {
    heading = "Reject Applicant";
    message = (
      <>
        {loader ? <Loader /> : null}
        <div className="d-grid gap-2">
          {changeContent && (
            <>
              <p>{kycTexts?.rejected}</p>
              <UiButton
                onClick={() => {
                  handleModalHide();
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Click to close this form&nbsp;&rarr;"
                type="submit"
              />
            </>
          )}
          {!changeContent && (
            <Row className="ml-1 align-items-center">
              <b>You are about to Reject:</b>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Id</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["applicantId"] : ""}
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Name</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["name"] : ""}
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Email</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["email"] : ""}
                </Col>
              </Row>
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Applicant Country</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  {selectedUser ? selectedUser["countryName"] : ""}
                </Col>
              </Row>

              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col className="pl-0">
                  <UiButton
                    onClick={async () => {
                      if (chainId) {
                        setLoader(true);
                        const abiCoder = new ethers.utils.AbiCoder();
                        await approveOrRejectApplicant(
                          selectedUser["applicantId"],
                          selectedUser["inspectionId"],

                          abiCoder.encode(
                            ["string", "string"],
                            [
                              selectedUser["id"],
                              selectedUser["id"]?.toLowerCase() !==
                              selectedUser["accountAddress"]?.toLowerCase()
                                ? `${
                                    String(selectedUser["acctChain"]) +
                                    "-" +
                                    selectedUser["accountAddress"]
                                  }`
                                : String(chainId),
                            ],
                          ),
                          {
                            reviewAnswer: "RED",
                          },
                        ).then((res) => {
                          setLoader(false);
                          if (res) {
                            toast.success(
                              "Applicant Rejected Succesfully",
                              ToastOptions,
                            );
                            setChangeContent(true);
                          } else {
                            toast.error(
                              "Applicant Rejection Failed",
                              ToastOptions,
                            );
                          }
                        });
                      }
                    }}
                    buttonVariant="danger"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText="Reject Applicant"
                    type="submit"
                  />
                </Col>
              </Row>
            </Row>
          )}
        </div>
      </>
    );
  }

  let clientContract;
  if (provider && provider.getSigner && chainId && address) {
    clientContract = new Client(signer, contractAddress[chainId].Client);
  }
  return (
    <>
      {kycLoading || generalLoading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="w-100">
          <div className="mb-3 d-flex flex-column justify-content-between w-100 align-items-flex-start">
            <h3 className="w-50 text-left">Pending KYC</h3>
            <div className="d-flex flex-row justify-content-between w-100 align-items-flex-start">
              <div className="w-100 text-left">
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    filterType === "" ? "Filter" : `Filtered By ${filterType}`
                  }
                >
                  {filterType !== "" && (
                    <Dropdown.Item
                      onClick={() => {
                        setFilterType("");
                        setFilterContent(null);
                        setNewData(null);
                      }}
                    >
                      Clear Filter
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => {
                      setFilterType("Name");
                      setModalView(7);
                      setShowModal(true);
                    }}
                  >
                    By name
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setFilterType("Date");
                      setModalView(7);
                      setShowModal(true);
                    }}
                  >
                    By date
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setFilterType("Status");
                      setModalView(7);
                      setShowModal(true);
                    }}
                  >
                    By status
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
          </div>
          <div className="pools-table width-100">
            {!newData && (
              <UiTable
                thead={headers}
                tbodyData={processedData ?? []}
                hover
                provider={provider}
                web3={web3}
                account={account}
                chainId={chainId}
                signature={userSignature}
                nonce={userSignatureNonce}
                commonProps={commonProps}
                networkOptions={networkOptions}
                verifiedWalletDetails={verifiedWalletDetails}
                signer={signer}
                contract={clientContract}
                bordered={false}
              />
            )}
            {newData && (
              <UiTable
                thead={headers}
                tbodyData={newData}
                hover
                provider={provider}
                web3={web3}
                account={account}
                chainId={chainId}
                signature={userSignature}
                nonce={userSignatureNonce}
                bordered={false}
                commonProps={commonProps}
                verifiedWalletDetails={verifiedWalletDetails}
                signer={signer}
              />
            )}
          </div>
        </div>
      </section>
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={handleModalHide}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>{heading}</b>
          </h2>
        }
        withFooter={false}
      >
        {message}
      </VerticallyModal>
    </>
  );
}

export default function ApprovedKYC(props) {
  return <KYCList {...props} />;
}
